module.exports = "/_next/static/images/29c6876c2c18bcf6aca9dfc305e5e454-two-people-looking-md@1x.jpg";